import React from 'react';
import { Icon } from '@chakra-ui/react';
import { LuGlobe } from 'react-icons/lu';
import { WebSourceOut } from '@/client';
import EvidenceTriggerButton from './EvidenceTriggerButton';

interface ChatResponseWebSourcesProps {
	/** External pages cited on a web-fallback answer — drives the trigger count. */
	webSources: WebSourceOut[];
	onOpen: (trigger: HTMLButtonElement) => void;
	hideOnMobile?: boolean;
}

/**
 * "N web sources" trigger. On mobile it can be hidden when document evidence is also present;
 * the document trigger then shows their combined count while the drawer tabs preserve the
 * provenance split.
 */
const ChatResponseWebSources: React.FC<ChatResponseWebSourcesProps> = (props: ChatResponseWebSourcesProps) => {
	const { webSources, onOpen, hideOnMobile = false } = props;
	const count = webSources.length;
	if (count === 0) return null;
	const triggerLabel = `${count} ${count === 1 ? 'web source' : 'web sources'}`;

	return (
		<EvidenceTriggerButton
			display={{ base: hideOnMobile ? 'none' : 'inline-flex', md: 'inline-flex' }}
			onClick={(event) => onOpen(event.currentTarget)}
		>
			<Icon as={LuGlobe} boxSize={4} />
			{triggerLabel}
		</EvidenceTriggerButton>
	);
};

export default ChatResponseWebSources;
